import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type IsRefundReturnState = string;

export const IS_REFUND_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsRefundReturnState>>,
): ConditionType<IsRefundReturnState, ModelCondition.IsRefundReturn> => ({
  name: "Requested refund on return",
  description() {
    return "Requested refund on return.";
  },
  Details(props: ConditionTypeDetailsProps<IsRefundReturnState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel() {
    return "";
  },
  toModel(state) {
    return { type: ModelCondition.IS_REFUND_RETURN, orderCount: state };
  },
  valid(state) {
    return state !== undefined;
  },
});
